import { Box, Tab, Tabs, Typography } from "@mui/material";
import { Dispatch, ReactElement, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import AddButton from "../../../common/components/functional/addButton/AddButton";
import { Entry } from "../entriesAPI";

type Props = {
  actionIcon?: ReactElement;
  handleFiltering: (value: number) => void;
  filterTab: number;
  setFilterTab: Dispatch<SetStateAction<number>>;
  setSelectedEntries: (val: Entry[]) => void;
  toggleNewEntryDialogOpen: (open: boolean) => void;
  toggleNewAbsenceDialogOpen: (open: boolean) => void;
  talentId?: string;
  isReadOnly: boolean;
};

const EntriesFilterTabs = ({
  actionIcon,
  handleFiltering,
  filterTab,
  setFilterTab,
  setSelectedEntries,
  toggleNewEntryDialogOpen,
  toggleNewAbsenceDialogOpen,
  talentId,
  isReadOnly,
}: Props) => {
  const handleTabChange = (value: number) => {
    setFilterTab(value);
    handleFiltering(value);
    setSelectedEntries([]);
  };

  const { t } = useTranslation(["hourEntries"]);

  const tabs = [
    { value: 0, label: `${t("CustomerRejected")}` },
    { value: 1, label: `${t("absence")}` },
    { value: 2, label: `${t("custom")}` },
  ];

  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        padding: "16px",
        borderRadius: "12px 12px 0 0",
      }}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap="52px"
      mb="20px"
    >
      <Box
        sx={{
          flex: "2",
          display: "flex",
          justifyContent: "space-between",
          height: "48px",
          backgroundColor: "#fff",
          borderRadius: "4px",
          boxShadow:
            "0px 2px 4px -2px rgba(129, 80, 190, 0.07), 0px 4px 6px -1px rgba(16, 24, 40, 0.1)",
          paddingRight: "1rem",
        }}
      >
        <Tabs sx={{ width: "90%" }} value={filterTab}>
          {tabs.map((tab) => (
            <Tab
              key={tab.value}
              sx={{ minWidth: "160px" }}
              label={
                <Typography sx={{ fontWeight: 700 }} variant="header">
                  {tab.label}
                </Typography>
              }
              onClick={() => handleTabChange(tab.value)}
            />
          ))}
        </Tabs>
        {actionIcon}
      </Box>

      {talentId && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <AddButton
            label={t("newAbsenceEntry")}
            variant="outlined"
            size="large"
            sx={{
              color: "#FF505A",
              borderColor: "#FF505A80",
              backgroundColor: "#FFFFFF",
              minHeight: "36px",
              borderRadius: "18px",
              padding: "6px 16px",
              marginRight: "16px",
              whiteSpace: "nowrap",
              flexShrink: 0,
              ":hover": {
                backgroundColor: "#FF505A4D",
                borderColor: "#FF505A80",
              },
            }}
            onClick={() => toggleNewAbsenceDialogOpen(true)}
            disabled={isReadOnly}
          />
          <AddButton
            label={t("newWorkTimeEntry")}
            variant="contained"
            size="large"
            sx={{
              minHeight: "36px",
              borderRadius: "18px",
              padding: "6px 16px",
              whiteSpace: "nowrap",
              flexShrink: 0,
            }}
            onClick={() => toggleNewEntryDialogOpen(true)}
            disabled={isReadOnly}
          />
        </Box>
      )}
    </Box>
  );
};

export default EntriesFilterTabs;
